import React from "react";

export const AttachIconSvg = (props) => {
  return (
    <>
      <svg
        className={props?.className}
        onClick={props?.onClick}
        width="15"
        height="9"
        viewBox="0 0 15 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.08273 0.0139398C9.38007 0.0139398 10.6851 -0.0307992 11.9824 0.0213963C13.8325 0.103418 15.2373 1.82587 14.9609 3.60797C14.6999 5.27823 13.3796 6.38925 11.637 6.38925C9.44148 6.38925 7.25366 6.38925 5.05817 6.38925C4.25213 6.38925 3.638 6.06116 3.26953 5.37517C2.91641 4.71899 2.95479 4.04791 3.38468 3.42902C3.76083 2.89215 4.29819 2.60135 4.9814 2.60135C7.22296 2.60135 9.47219 2.60135 11.7137 2.60135C11.898 2.60135 11.944 2.64609 11.9364 2.81759C11.921 3.07111 11.921 3.33208 11.9364 3.58561C11.9517 3.76456 11.8826 3.79439 11.7137 3.79439C9.49522 3.79439 7.27669 3.79439 5.05817 3.79439C4.4901 3.79439 4.14466 4.26415 4.33657 4.76373C4.44404 5.04708 4.68969 5.20367 5.05817 5.20367C5.68765 5.20367 6.31712 5.20367 6.9466 5.20367C8.50494 5.20367 10.0556 5.20367 11.614 5.20367C12.5966 5.20367 13.4026 4.65934 13.6713 3.83913C14.0935 2.54915 13.2107 1.23681 11.8135 1.20698C9.28795 1.16224 6.76236 1.13987 4.24445 1.22189C2.80126 1.26663 1.48857 2.50441 1.2813 3.89132C0.958885 6.06116 2.51723 7.80599 4.77414 7.80599C7.0771 7.80599 9.38007 7.80599 11.683 7.80599C11.898 7.80599 11.9594 7.85818 11.944 8.05951C11.921 8.29812 11.921 8.53673 11.944 8.77533C11.9594 8.9692 11.8903 8.99903 11.7061 8.99903C9.85602 8.99903 7.99829 8.99903 6.14824 8.99903C5.42664 8.99903 4.70505 9.03631 3.98345 8.96175C1.97987 8.73059 0.267994 7.06779 0.0376973 5.1291C-0.207953 3.10093 0.759294 1.31883 2.57864 0.446417C3.22347 0.133244 3.92204 -0.00097322 4.64363 -0.00097322C5.78744 -0.00097322 6.93893 -0.00097322 8.08273 -0.00097322C8.08273 -0.00097322 8.08273 0.00648328 8.08273 0.0139398Z"
          fill="#242021"
          style={{
            fill: "#242021",
            fill: "color(display-p3 0.1412 0.1255 0.1294)",
            fillOpacity: 1,
          }}
        />
      </svg>
    </>
  );
};
